const routes = [
  {
    name: 'sign',
    path: '/sign-up/pages',
    component: () => import('@pages/sign-up/home'),
  },
  {
    name: 'signGuide',
    path: '/sign/guide',
    component: () => import('@pages/sign-up/guide'),
  },
  {
    name: 'signResult',
    path: '/sign/result',
    component: () => import('@pages/sign-up/result'),
  },
];

export default routes;
